export default function PersonIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0937 5.0625C11.9559 6.92121 10.5469 8.4375 9 8.4375C7.45312 8.4375 6.0416 6.92156 5.90625 5.0625C5.76562 3.12891 7.13672 1.6875 9 1.6875C10.8633 1.6875 12.2344 3.16406 12.0937 5.0625Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.99999 10.6875C5.9414 10.6875 2.8371 12.375 2.26265 15.5602C2.19339 15.9441 2.41066 16.3125 2.81249 16.3125H15.1875C15.5897 16.3125 15.8069 15.9441 15.7377 15.5602C15.1629 12.375 12.0586 10.6875 8.99999 10.6875Z"
        stroke="currentColor"
        strokeMiterlimit="10"
      />
    </svg>
  )
}
